module.exports = __webpack_public_path__ + "static/media/third-block-img1.00a7e9e7.svg";